import store from 'store/configureStore';
import { AVAILABLE, AWAY, UNAVAILABLE } from 'modules/common/constants/userAvailabilityTypes';
import { conferenceInProgress, isInWaitingRoom } from 'modules/conference/selectors/consultationInfo';

export const selfAvailability = (userId, currentAvailability) => {
  if ([AWAY, AVAILABLE].includes(currentAvailability)) {
    return currentAvailability;
  }

  const state = store.getState();

  switch (true) {
    case userId === state.auth.userInfo.userId && (conferenceInProgress(state) || isInWaitingRoom(state)):
      return AWAY;
    case userId === state.auth.userInfo.userId:
      return AVAILABLE;
    default:
      return UNAVAILABLE;
  }
};
